import { useQuery } from 'react-query';

// Import types
import type { AgreementsType } from 'types/api/agreements';

// Import helpers
import { fetchAgreements } from 'helpers/api/agreements';

export const useRegulation = (agreements: string[]) => {
	const { data = [], isLoading } = useQuery<AgreementsType>({
		queryKey: agreements,
		queryFn: fetchAgreements.bind(null, agreements)
	});

	const agreementsIds = data.map(({ version }) => version.id);

	return { agreements: data, agreementsIds, isLoading };
};
